import {
    Translation,
    TRANSLOCO_CONFIG,
    TRANSLOCO_LOADER,
    translocoConfig,
    TranslocoModule,
    TranslocoService,
} from "@ngneat/transloco";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { environment } from "environments/environment";
import { TranslocoHttpLoader } from "app/core/transloco/transloco.http-loader";
import { catchError, firstValueFrom, of } from "rxjs";

@NgModule({
    exports: [TranslocoModule],
    providers: [
        {
            // Provide the default Transloco configuration
            provide: TRANSLOCO_CONFIG,
            useValue: translocoConfig({
                availableLangs: [
                    {
                        id: "en",
                        label: "English",
                    },
                    {
                        id: "es",
                        label: "Español",
                    },
                    {
                        id: "fr",
                        label: "Français",
                    },
                ],
                defaultLang: "en",
                fallbackLang: "en",
                reRenderOnLangChange: true,
                prodMode: environment.production,
            }),
        },
        {
            // Provide the default Transloco loader
            provide: TRANSLOCO_LOADER,
            useClass: TranslocoHttpLoader,
        },
        {
            // Preload the default language before the app starts to prevent empty/jumping content.
            // Must tolerate abort/EMPTY: Keycloak login-required can cancel the i18n XHR during bootstrap;
            // Transloco then completes empty and firstValueFrom would throw EmptyError.
            provide: APP_INITIALIZER,
            deps: [TranslocoService],
            useFactory:
                (translocoService: TranslocoService): (() => Promise<Translation>) =>
                (): Promise<Translation> => {
                    const defaultLang = translocoService.getDefaultLang();
                    const emptyTranslation: Translation = {};
                    translocoService.setActiveLang(defaultLang);
                    return firstValueFrom(
                        translocoService.load(defaultLang).pipe(
                            catchError(error => {
                                console.warn(`Transloco preload failed for "${defaultLang}"`, error);
                                return of(emptyTranslation);
                            })
                        ),
                        { defaultValue: emptyTranslation }
                    );
                },
            multi: true,
        },
    ],
})
export class TranslocoCoreModule {}
